// extracted by mini-css-extract-plugin
export var rateTable = "_3q-0";